var p = (i, l, e) => new Promise((n, c) => {
  var a = (t) => {
    try {
      o(e.next(t));
    } catch (s) {
      c(s);
    }
  }, u = (t) => {
    try {
      o(e.throw(t));
    } catch (s) {
      c(s);
    }
  }, o = (t) => t.done ? n(t.value) : Promise.resolve(t.value).then(a, u);
  o((e = e.apply(i, l)).next());
});
import { m as f, u as S, a as w, o as b, b as k, c as C, e as _, h as I, t as g, k as h, aq as V } from "./define-element-XpjsV6s1.js";
import { _ as x } from "./Icon-CGbhZCm-.js";
import { u as L } from "./use-cart-D8NOb7eE.js";
import { _ as R } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const T = ["aria-label"], $ = {
  key: 0,
  class: "offset-cart-count-number",
  "aria-hidden": "true"
}, q = {
  __name: "CartCount",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(i) {
    const l = i, { cart: e, isLoadingCart: n, loadCart: c } = L(), a = f(() => {
      var r;
      return (((r = e.value) == null ? void 0 : r.items) || []).reduce((v, y) => v + (y.quantity || 0), 0);
    }), u = f(() => n.value ? ".." : a.value), o = f(() => n.value ? "View cart" : a.value > 0 ? `View cart, ${a.value} item${a.value === 1 ? "" : "s"}` : "View cart, empty");
    function t() {
      var r;
      ((r = OFFSET == null ? void 0 : OFFSET.showSideCart()) != null ? r : !1) || (location.href = V());
    }
    const s = S("container"), m = w(!1);
    return b(() => p(null, null, function* () {
      k(s.value, l.inheritStyle), yield c(), m.value = !0;
    })), (d, r) => !m.value || a.value > 0 ? (C(), _("button", {
      key: 0,
      type: "button",
      class: "offset-cart-count",
      ref: "container",
      "aria-label": o.value,
      onClick: t
    }, [
      I(x, {
        name: "shopping-cart",
        class: "offset-cart-count-icon",
        "aria-hidden": "true"
      }),
      u.value ? (C(), _("span", $, g(u.value), 1)) : h("", !0)
    ], 8, T)) : h("", !0);
  }
}, A = /* @__PURE__ */ R(q, [["__scopeId", "data-v-c7713815"]]);
export {
  A as C
};
